(() => {
    window.$ = jQuery;
    const SELECTOR_SLICK = '.cross_sell__slick';
    const SETTINGS_SLICK = {
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">&#10094;</button>',
        nextArrow: '<button type="button" class="slick-next">&#10095;</button>',
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                }
            },
            {   
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                }
            }
        ],
    };

    const initSlick = () => {
        const element = $(SELECTOR_SLICK);

        element.slick(SETTINGS_SLICK);
    };

    document.addEventListener('DOMContentLoaded', () => {
        initSlick();
    });

})()